import { createAction } from 'redux-actions';

export const getFolderListAction = createAction('REQUEST/GET_FOLDER_LIST');

export const addFormFolderAction = createAction('REQUEST/ADD_FORM_FOLDER');

export const editFormFolderAction = createAction('REQUEST/EDIT_FORM_FOLDER');

export const deleteFormFolderAction = createAction('REQUEST/DELETE_FORM_FOLDER');
